import React, { Component } from 'react'
import { withRouter, Prompt } from 'react-router-dom'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { injectState } from 'freactal'
import {
  getSlide,
  getSectionIndexArray,
  getSectionHeading,
  serializeContentSection,
} from '../../../lib'
import { Raw } from 'slate'

import {
  Grid,
  Cell,
  Card as UnstyledCard,
  Spinner,
  Switch,
  Textfield,
} from 'react-mdl'
import Button from '../../../components/Button'
import AutoScale from 'react-auto-scale'
import DisplayError from '../../../components/DisplayError'
import Editor from '../../../components/Editor'
import ImageSelectionModal from '../../../components/ImageSelectionModal'
import Slide from './Slide'

const Heading = styled.h5`
  margin: 0;
  margin-bottom: 0.25em;
`
const Card = styled(UnstyledCard)`
  overflow: visible;
  padding: 0.5em;
  width: 100%;
  min-height: 0;
  margin-bottom: 0.25em;
`
const InlineElements = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`
const SwitchContainer = styled.div`
  width: 40px;
  margin-left: 5px;
`

class SlideContent extends Component {
  static contextTypes = { prompt: PropTypes.func }
  state = {}
  componentWillMount() {
    const {
      state: { unit },
      match: { params: { sectionIndex, slideIndex } },
    } = this.props
    this.receiveSlideContent(unit, sectionIndex, slideIndex)
  }
  componentWillReceiveProps({
    state: { unit },
    match: { params: { sectionIndex, slideIndex } },
  }) {
    const {
      match: {
        params: { sectionIndex: oldSectionIndex, slideIndex: oldSlideIndex },
      },
    } = this.props
    if (oldSectionIndex !== sectionIndex || oldSlideIndex !== slideIndex) {
      this.receiveSlideContent(unit, sectionIndex, slideIndex)
    }
  }
  receiveSlideContent = (unit, sectionIndex, slideIndex) => {
    const sectionIndexArr = getSectionIndexArray(sectionIndex)
    const slide = getSlide(unit, sectionIndexArr, slideIndex)
    this.state = {
      savePending: false,
      sectionIndexArr,
      contentState: this.deserializeState(slide.content),
      notesState: this.deserializeState(slide.notes),
      ...slide,
    }
  }
  deserializeState(state) {
    if (state == null || state.nodes.length === 0) {
      state = {
        nodes: [
          {
            kind: 'block',
            type: 'paragraph',
            nodes: [
              {
                kind: 'text',
                text: '',
              },
            ],
          },
        ],
      }
    }
    return Raw.deserialize(state, { terse: true })
  }
  handleContentChange = contentState =>
    this.setState({ contentState, savePending: true })
  handleNotesChange = notesState =>
    this.setState({ notesState, savePending: true })
  handleImageChange = image => this.setState({ image, savePending: true })
  handleImageWidthChange = ({ target }) => {
    this.setState(({ image }) => ({
      savePending: true,
      image: {
        ...image,
        display: {
          ...image.display,
          width: parseFloat(target.value, 10),
        },
      },
    }))
  }
  handleImageAlignmentChange = ({ target }) => {
    const align = target.checked ? 'right' : 'center'
    this.setState(({ image }) => ({
      savePending: true,
      image: {
        ...image,
        display: {
          ...image.display,
          align,
        },
      },
    }))
  }
  handleDelete = async () => {
    if (!global.confirm('Are you sure you wish to delete this slide?')) return
    const {
      history,
      match: { params: { unitId, sectionIndex, slideIndex } },
      state: { unit },
      effects: { deleteSlide },
    } = this.props
    const sectionIndexArr = getSectionIndexArray(sectionIndex)
    const { _id: slideId } = getSlide(unit, sectionIndexArr, slideIndex)
    await deleteSlide({
      _id: unitId,
      sectionIndex,
      slideId,
    })
    history.push(`/units/${unitId}/presentation/${sectionIndex}/0/`)
  }
  handleSave = async () => {
    const {
      match: { params: { unitId, sectionIndex, slideIndex } },
      effects: { updateSlide },
    } = this.props
    const { image, contentState, notesState } = this.state
    const content = serializeContentSection(contentState)
    const notes = serializeContentSection(notesState)
    this.setState({ saving: true })
    await updateSlide({
      _id: unitId,
      sectionIndex,
      slideIndex,
      slide: {
        content,
        notes,
        image,
      },
    })
    this.setState({ saving: false, savePending: false })
  }
  handleDuplicateSlide = async () => {
    const {
      match: { params: { unitId, sectionIndex /*, slideIndex */ } },
      effects: { addSlide },
    } = this.props
    const { image, contentState, notesState } = this.state
    const content = serializeContentSection(contentState)
    const notes = serializeContentSection(notesState)
    this.setState({ saving: true })
    await addSlide({
      _id: unitId,
      sectionIndex,
      // slideIndex,
      slide: {
        content,
        notes,
        image,
      },
    })
    this.setState({ saving: false })
  }
  changeImage = async () => {
    const { state: { unit } } = this.props
    const scopeContent = getSectionHeading(unit, this.state.sectionIndexArr)
    const response = await this.context.prompt({
      ContentComponent: props => (
        <ImageSelectionModal
          {...props}
          unitImages={unit.images || []}
          imageLimit={1}
          scopeContent={scopeContent}
        />
      ),
      style: {
        top: '2em',
        width: 850,
      },
    })
    if (response === 'cancel') return
    const [image] = response
    this.handleImageChange(image)
  }
  render() {
    const {
      match: { params: { slideIndex } },
      state: { updateSlideError, duplicateSlideError },
    } = this.props
    const {
      image,
      sectionIndexArr,
      contentState,
      notesState,
      saving,
      savePending,
    } = this.state
    const imageAlignment = image && image.display ? image.display.align : null
    const slide = {
      image,
      sectionIndex: sectionIndexArr,
      content: Raw.serialize(contentState),
      // no need to also serialize notes, slide preview doesn't render them
    }
    return (
      <Grid>
        <Cell col={8}>
          <Card shadow={0} style={{ zIndex: 3 }}>
            <Heading>Slide Content</Heading>
            <Editor
              state={contentState}
              removeButtons={['image', 'styleSelector']}
              onChange={this.handleContentChange}
            />
          </Card>
          <Card shadow={0} style={{ zIndex: 2 }}>
            <Heading>Slide Notes</Heading>
            <Editor
              state={notesState}
              removeButtons={['image', 'styleSelector', 'table']}
              onChange={this.handleNotesChange}
            />
          </Card>
          <Card shadow={0}>
            <Heading>Image</Heading>
            <InlineElements>
              <Textfield
                label="Size (cm):"
                floatingLabel
                disabled={!image}
                type="number"
                value={(image && image.display && image.display.width) || 5.5}
                onChange={this.handleImageWidthChange}
              />
              <InlineElements>
                <b>Location:</b>
                Center
                <SwitchContainer>
                  <Switch
                    disabled={!image}
                    onChange={this.handleImageAlignmentChange}
                    checked={imageAlignment !== 'center'}
                  />
                </SwitchContainer>
                Right
              </InlineElements>
              <Button raised onClick={this.changeImage}>
                Change image
              </Button>
            </InlineElements>
          </Card>
          <DisplayError error={updateSlideError} />
          <DisplayError error={duplicateSlideError} />
          <InlineElements>
            {saving ? (
              <Spinner />
            ) : (
              <Button raised primary onClick={this.handleSave}>
                Save Changes
              </Button>
            )}
            <Button
              raised
              accent
              disabled={slideIndex === '0'}
              onClick={this.handleDelete}>
              Delete Slide
            </Button>
          </InlineElements>
        </Cell>
        <Cell col={4}>
          <Card shadow={0}>
            <Heading>Slide preview</Heading>
            <AutoScale>
              <Slide slide={slide} />
            </AutoScale>
            {saving ? (
              <Spinner />
            ) : (
              <Button raised primary onClick={this.handleDuplicateSlide}>
                Duplicate Slide
              </Button>
            )}
          </Card>
        </Cell>
        <Prompt
          when={savePending}
          message="You have unsaved changes to this slide. Are you sure you wish to discard them?"
        />
      </Grid>
    )
  }
}

export default withRouter(injectState(SlideContent))



// WEBPACK FOOTER //
// ./src/Units/ManageUnit/PresentationContent/SlideContent.js